const machineNameLookup = (uiSchema) => {
  let lookup = {};
  uiSchema.map((page, page_num) => {
    page.sections.map((section) => {
      if (section.fields) {
        section.fields.map((field) => {
          // lookup array expects:
          // 0: page number
          // 1: field code
          // 2: field label
          // if lookup is a group
          // same as above +
          // 3: null ?
          // 4: "list" or null
          // 5: group's label

          if (!field.isGroup && field.machine_name !== undefined) {
            lookup[field.machine_name] = [
              page_num,
              field.code,
              field.label !== undefined
                ? field.label.replace(/"/g, "'")
                : "no label",
              field.reviewHidden || false,
            ];
          } else if (
            !field.isGroup &&
            !!field.rows &&
            Array.isArray(field.rows) &&
            field.widget === "generic_table"
          ) {
            field.rows.forEach((row) => {
              row.forEach((cell) => {
                lookup[cell.machine_name] = [
                  page_num,
                  cell.code !== undefined ? cell.code : "",
                  cell.label !== undefined
                    ? cell.label.replace(/"/g, "'")
                    : "no label",
                  cell.reviewHidden || false,
                ];
              });
            });
          } else if (field.isGroup) {
            let groupLabel = field.isGroup.label ? field.isGroup.label : "";

            // field of groups with group machine name but no individual field machine names
            if (
              field.isGroup.machine_name !== undefined &&
              field.isGroup.fields[0].machine_name === undefined
            ) {
              lookup[field.isGroup.machine_name] = [
                page_num,
                field.isGroup.code,
                field.isGroup.label !== undefined
                  ? field.isGroup.label.replace(/"/g, "'")
                  : "no label",
                null,
                null,
                groupLabel,
              ];
              lookup[field.isGroup.machine_name].push({ ...field });
            } else {
              // no machine name for the group, located in individual fields
              field.isGroup.fields.map((f) => {
                if (f.machine_name) {
                  lookup[f.machine_name] = [
                    page_num,
                    f.code !== undefined ? f.code : field.isGroup.code,
                    f.label !== undefined
                      ? f.label.replace(/"/g, "'")
                      : "no label",
                    null,
                    ["checkbox", "checkbox_old"].includes(f.widget)
                      ? "list"
                      : null,
                    groupLabel,
                  ];
                  lookup[f.machine_name].push({ ...f });
                } else {
                  console.error(
                    "Field group has no machine name and neither does this subfield: ",
                    f
                  );
                }
              });
            }
          } else {
            // probably an inlinePrefiller
          }
        });
      } else {
        // section has no 'fields'
        if (section.isTableInput === true) {
          lookup[section.machine_name] = [
            page_num,
            section.code,
            section.label,
            section.columnHeaders,
          ];
        } else if (section.isFieldArray === true) {
          lookup[section.machine_name] = [
            page_num,
            section.code,
            section.fieldArray.info,
            undefined,
          ];
        } else {
          if (
            section &&
            section.machine_name &&
            section.machine_name[0] !== "_"
          ) {
            let columnHeaders = [];
            if (section.modalFields) {
              section.modalFields.map((field) => {
                columnHeaders.push(field.label);
              });
            }
            // if not one of our own machine names (prefixed by _ like addendum C inlines)
            lookup[section.machine_name] = [
              page_num,
              section.code,
              section.sectionHeader,
              columnHeaders,
            ];
          } else {
            // console.log(section)
          }
        }
      }
    });
  });
  return lookup;
};

export default machineNameLookup;
